import type { Venue } from '../types/venues';

export const sampleVenues: Venue[] = [
  {
    id: '1',
    name: 'Elegant Garden Estate',
    location: 'Colombo 07, Western Province',
    city: 'Colombo',
    price: 450000,
    capacity: 150,
    rating: 4.8,
    reviews: 24,
    image: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=800&h=600&fit=crop',
    venueType: 'hybrid',
    features: ['Garden Ceremony', 'Indoor Reception', 'Catering Kitchen', 'Bridal Suite'],
    description: 'A stunning colonial-style estate with manicured gardens perfect for outdoor ceremonies and elegant indoor receptions.',
    contact: {
      phone: '+94 11 234 5678',
      email: 'info@elegantgarden.lk',
      website: 'www.elegantgarden.lk'
    },
    amenities: ['Parking for 50 cars', 'Sound System', 'Lighting', 'Tables & Chairs'],
    priceIncludes: ['Venue rental for 8 hours', 'Basic lighting', 'Tables and chairs', 'Bridal suite access']
  },
  {
    id: '2',
    name: 'Beachside Paradise Resort',
    location: 'Bentota, Southern Province',
    city: 'Bentota',
    price: 650000,
    capacity: 200,
    rating: 4.9,
    reviews: 18,
    image: 'https://images.unsplash.com/photo-1464207687429-7505649dae38?w=800&h=600&fit=crop',
    venueType: 'outdoor',
    features: ['Beach Ceremony', 'Ocean View', 'Accommodation', 'Sunset Photography'],
    description: 'An exclusive beachfront resort offering breathtaking ocean views and luxury accommodations for your special day.',
    contact: {
      phone: '+94 34 567 8901',
      email: 'weddings@beachsideparadise.lk',
      website: 'www.beachsideparadise.lk'
    },
    amenities: ['Private beach access', 'Accommodation for 20 guests', 'Spa services', 'Water sports'],
    priceIncludes: ['Beach ceremony setup', 'Reception dinner', 'Accommodation for couple', 'Photography locations']
  },
  {
    id: '3',
    name: 'Historic Manor House',
    location: 'Kandy, Central Province',
    city: 'Kandy',
    price: 350000,
    capacity: 120,
    rating: 4.7,
    reviews: 31,
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800&h=600&fit=crop',
    venueType: 'indoor',
    features: ['Historic Architecture', 'Gardens', 'Bridal Suite', 'Heritage Setting'],
    description: 'A beautifully preserved colonial manor house with rich history and elegant interiors, perfect for intimate celebrations.',
    contact: {
      phone: '+94 81 234 5678',
      email: 'events@historicmanor.lk',
      website: 'www.historicmanor.lk'
    },
    amenities: ['Historic gardens', 'Vintage decor', 'Piano', 'Library lounge'],
    priceIncludes: ['Venue rental for 6 hours', 'Garden access', 'Vintage furniture', 'Bridal preparation room']
  },
  {
    id: '4',
    name: 'Mountain View Pavilion',
    location: 'Nuwara Eliya, Central Province',
    city: 'Nuwara Eliya',
    price: 280000,
    capacity: 100,
    rating: 4.6,
    reviews: 15,
    image: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&h=600&fit=crop',
    venueType: 'outdoor',
    features: ['Mountain Views', 'Cool Climate', 'Tea Plantation Setting', 'Photography Spots'],
    description: 'A scenic pavilion nestled in the hills with panoramic mountain views and cool climate perfect for daytime celebrations.',
    contact: {
      phone: '+94 52 345 6789',
      email: 'bookings@mountainview.lk',
      website: 'www.mountainviewpavilion.lk'
    },
    amenities: ['Mountain hiking trails', 'Tea plantation tours', 'Cool weather', 'Scenic photography'],
    priceIncludes: ['Pavilion rental', 'Mountain view access', 'Basic seating', 'Photography permissions']
  },
  {
    id: '5',
    name: 'Royal Ballroom Hotel',
    location: 'Colombo 03, Western Province',
    city: 'Colombo',
    price: 750000,
    capacity: 300,
    rating: 4.9,
    reviews: 67,
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&h=600&fit=crop',
    venueType: 'indoor',
    features: ['Grand Ballroom', 'Luxury Service', 'City Views', 'Valet Parking'],
    description: 'An opulent hotel ballroom in the heart of Colombo, offering world-class service and stunning city skyline views.',
    contact: {
      phone: '+94 11 567 8901',
      email: 'weddings@royalballroom.lk',
      website: 'www.royalballroomhotel.lk'
    },
    amenities: ['Valet parking', '5-star catering', 'Luxury suites', 'Concierge service'],
    priceIncludes: ['Ballroom rental for 10 hours', 'Luxury table settings', 'Professional lighting', 'Dedicated coordinator']
  },
  {
    id: '6',
    name: 'Tropical Garden Villa',
    location: 'Negombo, Western Province',
    city: 'Negombo',
    price: 320000,
    capacity: 80,
    rating: 4.5,
    reviews: 22,
    image: 'https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=800&h=600&fit=crop',
    venueType: 'hybrid',
    features: ['Tropical Gardens', 'Pool Area', 'Intimate Setting', 'Beach Access'],
    description: 'A charming villa surrounded by lush tropical gardens with pool area and easy beach access for smaller, intimate weddings.',
    contact: {
      phone: '+94 31 456 7890',
      email: 'info@tropicalvilla.lk',
      website: 'www.tropicalvilla.lk'
    },
    amenities: ['Swimming pool', 'Beach access', 'Tropical landscaping', 'BBQ area'],
    priceIncludes: ['Villa rental for 8 hours', 'Garden and pool access', 'Basic furniture', 'Beach photography']
  }
];

export const venueLocations = [
  'All Locations',
  'Colombo',
  'Kandy',
  'Bentota',
  'Negombo',
  'Nuwara Eliya',
  'Galle',
  'Anuradhapura'
];

export const venueTypes = [
  { value: 'all', label: 'All Types' },
  { value: 'indoor', label: 'Indoor' },
  { value: 'outdoor', label: 'Outdoor' },
  { value: 'hybrid', label: 'Indoor & Outdoor' }
];